interface LogoProps {
  size?: number;
  className?: string;
  monogram?: boolean;
}

/**
 * Custom MNF logo: a sprouting trefoil sitting in a chalice — three leaves
 * for Move / Nourish / Flourish, holding a small fruit. Currentcolor only.
 */
export default function Logo({ size = 28, className = "", monogram = false }: LogoProps) {
  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={className}
      aria-label="Move Nourish Flourish"
      fill="none"
    >
      {/* chalice base */}
      <path
        d="M16 50 Q32 58 48 50 L46 44 Q32 50 18 44 Z"
        fill="currentColor"
        opacity="0.9"
      />
      <path
        d="M22 44 L20 32 Q32 36 44 32 L42 44 Q32 48 22 44 Z"
        fill="currentColor"
        opacity="0.7"
      />
      {/* center leaf */}
      <path
        d="M32 8 C28 14 28 24 32 30 C36 24 36 14 32 8 Z"
        fill="currentColor"
      />
      {/* left leaf */}
      <path
        d="M14 18 C16 24 22 28 28 28 C26 22 22 16 14 18 Z"
        fill="currentColor"
        opacity="0.85"
      />
      {/* right leaf */}
      <path
        d="M50 18 C48 24 42 28 36 28 C38 22 42 16 50 18 Z"
        fill="currentColor"
        opacity="0.85"
      />
      {/* berry */}
      {!monogram && (
        <circle cx="32" cy="34" r="3" fill="currentColor" opacity="0.6" />
      )}
    </svg>
  );
}
